<template>
  <div class="kk_designer-arrows" :style="{ gridArea: `${rowIndex + 2} / 2 / ${rowIndex + 3} / -1 ` }">
    <arrow
      v-for="arrow in arrows"
      :id="arrow.id"
      :key="arrow.id"
      :row-id="rowId"
      :arrow="arrow"
      :get-px-from-column-index="getPxFromColumnIndex"
      :get-px-from-row-index="getPxFromRowIndex"
      :get-index-at-row-px="getIndexAtRowPx"
      :get-index-at-column-px="getIndexAtColumnPx"
    />
  </div>
</template>
<script>
import DesignerMixin from "../../DesignerMixin";
import { ColumnTypes } from "../../cell/CellConstants";
import Arrow from "./Arrow.vue";
export default {
  components: {
    Arrow,
  },
  mixins: [DesignerMixin],
  props: ["rowId", "rowIndex", "getPxFromRowIndex", "getPxFromColumnIndex", "getIndexAtColumnPx", "getIndexAtRowPx"],
  computed: {
    arrows() {
      return this.$store.state.cells.current?.design.arrows[this.rowId];
    },
    firstPlayerIndex() {
      return this.columns.findIndex((item) => item.type === ColumnTypes.Player);
    },
  },
};
</script>
<style lang="less" scoped>
.kk_designer-arrows {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
